import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PubBdRequest } from '../domain/bd/pub-bd-request.model';
import { environment } from '../../../environments/environment';
import { Page } from '../domain/page.model';
import { BlocklistFilter } from '../../publisher/blocklist/domain/blocklist-filter.model';
import { Utils } from '../utils/utils';
import { Observable } from 'rxjs';
import { CreativeAttribute } from '../domain/bd/creative-attribute.model';
import { PubBdRequestAction } from '../domain/bd/pub-bd-request-action.model';
import { IabContentTaxonomyT1 } from '../domain/iab-content-taxonomy.model';

@Injectable()
export class PubBlockRequestService {

  constructor(private httpClient: HttpClient) {
  }

  createRequest(request: PubBdRequest) {
    return this.httpClient.post(`${environment.serviceUrl}/ad-stats/pub-block-request`, request);
  }

  deleteRequest(request: PubBdRequest) {
    return this.httpClient.delete(`${environment.serviceUrl}/ad-stats/pub-block-request/${request.id}`);
  }

  rejectRequest(request: PubBdRequest, comment: string) {
    return this.httpClient.post(`${environment.serviceUrl}/ad-stats/pub-block-request/${request.id}/reject`, comment);
  }

  updateRequest(request: PubBdRequest) {
    return this.httpClient.put(`${environment.serviceUrl}/ad-stats/pub-block-request/${request.id}`, request);
  }

  getRequests(filter: BlocklistFilter) {
    return this.httpClient.get<Page<PubBdRequest>>(`${environment.serviceUrl}/ad-stats/pub-block-request?${Utils.getUrlParamsFrom(filter)}`);
  }

  actionsGet(id: string): Observable<PubBdRequestAction[]> {
    return this.httpClient.get<PubBdRequestAction[]>(`${environment.serviceUrl}/ad-stats/pub-block-request/${id}/actions`);
  }

  actionPut(action: PubBdRequestAction): Observable<PubBdRequestAction> {
    return this.httpClient.put<PubBdRequestAction>(`${environment.serviceUrl}/ad-stats/pub-block-action/${action.id}`, action);
  }

  getTaxonomies(): Observable<string[]> {
    return this.httpClient.get<string[]>(`${environment.serviceUrl}/ad-stats/pub-block-request/available-taxonomies`);
  }
  getTaxonomiesWithSubcategories(): Observable<IabContentTaxonomyT1[]> {
    return this.httpClient.get<IabContentTaxonomyT1[]>(`${environment.serviceUrl}/ad-stats/pub-block-request/available-taxonomies-with-subcategories`);
  }

  getCreativeAttributes(): Observable<CreativeAttribute[]> {
    return this.httpClient.get<CreativeAttribute[]>(`${environment.serviceUrl}/ad-stats/pub-block-request/available-creatives`);
  }

  uploadFile(file: File, request: PubBdRequest) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.httpClient.post(`${environment.serviceUrl}/ad-stats/pub-block-request/${request.id}/files`, formData);
  }
}
